define('plugin/promotion/model/PromotionModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Promotion data model
     *
     * @class PromotionModel
     */
    return BaseModel.extend({

        url: '/ext/promotion/item/',

        defaults: {
            id: null,
            name: '',
            description: '',
            file_id: null,
            picture_preview: null,
            picture_large: null,
            is_visible: true,
            is_active:true,
            position: 0,
            price: 0,
            tax: null,
            discount_type: '',
            discount: 0,
            duration_type: '',
            duration: 0
        }

    });

});
